module.exports = __webpack_public_path__ + "img/deepseek-slogan@2x.351219e0.png";